var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('h1',[_vm._v("Data flow for Soundslides based TMAs")]),_c('ZipToForageImporter',{attrs:{"id":_vm.$store.state.forageDataShowId}}),_c('ForageImporter',{attrs:{"id":_vm.$store.state.forageDataShowId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }